import { create } from "zustand";

const DEFAULT_REFETCH_INTERVAL_MS = 5000; //5s

export type TAIProgressStore = {
  isInProgress: boolean;
  refetchInterval: number;
  refetchKey: string;
  onSetIsInProgress: (isInProgress: boolean) => void;
  onResetRefetchInterval: () => void;
  onUpdateRefetchInterval: () => void;
  onSetRefetchKey: (refetchKey: string) => void;
};

export const useAIProgressStore = create<TAIProgressStore>((set) => ({
  isInProgress: true,
  refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
  refetchKey: "initial",
  onSetIsInProgress: (isInProgress) => {
    set({ isInProgress });
  },
  onResetRefetchInterval: () => {
    set({ refetchInterval: DEFAULT_REFETCH_INTERVAL_MS });
  },
  onUpdateRefetchInterval: () => {
    set((state) => {
      return {
        ...state,
        // implement exponential backoff with adding prev value + (prev value / 3)
        refetchInterval:
          state.refetchInterval + Math.floor(state.refetchInterval / 3),
      };
    });
  },
  onSetRefetchKey: (refetchKey) => {
    set({ refetchKey });
  },
}));
